module.exports = __webpack_public_path__ + "static/media/All_Elements.2133e7f7.png";